import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-04470f97"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["src"]


const __default__ = {
  name: 'TeamAvatar'
}

import { ref, reactive, toRef } from 'vue'
import { uploadGroupAvatar } from '@teams/common/api'
import Icon from '@teams/common/components/icon'
import { useAppDialog } from '@/components/appDialog'
import handleResponseError from '@teams/common/hooks/useResponseError'

type PropsType = typeof props


export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
  allowUpload: {
    type: Boolean,
    default: true
  },
  modelValue: {
    type: String,
    default: ''
  },
  groupId: {
    type: Number,
    required: true
  }
},
  emits: ['update:modelValue'],
  setup(__props, { emit }) {

const props = __props

const appDialog = useAppDialog()




const loading = ref<boolean>(false)
const useAvatarEditor = (props: PropsType) => {
  const allowUpload = toRef(props, 'allowUpload', false)
  const isShowUploadTips = ref<boolean>(false)

  // 是否显示上传图标
  const updateUploadTips = () => {
    if (!allowUpload.value) {
      return
    }
    isShowUploadTips.value = !isShowUploadTips.value
  }
  const showAvatarEditor = () => {
    if (!allowUpload.value) return
    appDialog.show({
      name: 'SelectAvatar',
      componentProps: {
        loading,
        onConfirm: async (value: string, dialogFunc) => {
          // 调用
          if (value) {
            loading.value = true
            const picUrl = await uploadRequest(value)
            if (picUrl) {
              emit('update:modelValue', picUrl)
              loading.value = false
              dialogFunc?.close?.()
            }
          }
        },
        modelValue: props.modelValue
      }
    })
  }

  const uploadRequest = async (fileValue: string) => {
    let picUrl: string | undefined
    try {
      const res = await uploadGroupAvatar({
        group_id: props.groupId,
        data: fileValue
      })
      picUrl = res.data.pic
    } catch (e) {
      handleResponseError(e)
    }
    return picUrl
  }

  return reactive({
    isShowUploadTips,
    updateUploadTips,
    showAvatarEditor
  })
}

const avatarEditor = useAvatarEditor(props)

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("a", {
      class: "team-avatar",
      style: _normalizeStyle({ cursor: __props.allowUpload ? 'pointer' : '' }),
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_unref(avatarEditor).showAvatarEditor && _unref(avatarEditor).showAvatarEditor(...args))),
      onMouseenter: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_unref(avatarEditor).updateUploadTips && _unref(avatarEditor).updateUploadTips(...args))),
      onMouseleave: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_unref(avatarEditor).updateUploadTips && _unref(avatarEditor).updateUploadTips(...args)))
    }, [
      _createElementVNode("img", {
        src: __props.modelValue,
        alt: ""
      }, null, 8, _hoisted_1),
      _createElementVNode("div", {
        class: _normalizeClass(_unref(avatarEditor).isShowUploadTips ? 'team-avatar__mask' : '')
      }, [
        _createVNode(_unref(Icon), {
          name: "uploadAvatar",
          fill: "transparent"
        })
      ], 2)
    ], 36)
  ]))
}
}

})